import { getCsioConfig } from './config';
export var resolveMediaUrl = function (path) {
    if (!path || typeof path !== 'string')
        return '';
    var trimmed = path.trim();
    if (!trimmed)
        return '';
    if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith('data:')) {
        return trimmed;
    }
    var mediaOrigin = getCsioConfig().mediaOrigin;
    if (!mediaOrigin) {
        return trimmed.startsWith('/') ? trimmed : "/".concat(trimmed);
    }
    var normalized = trimmed.startsWith('/') ? trimmed : "/".concat(trimmed);
    return "".concat(mediaOrigin).concat(normalized);
};
